import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { WindowRef } from '@vendor/window/window.component';

@Injectable({ providedIn: 'root' })
export class CheckService {

    private handler: any;
    private nativeWindow: Window;

    constructor(private http: HttpClient,
                @Inject(DOCUMENT) private document: any,
                windowRef: WindowRef
    ) {
        this.nativeWindow = windowRef.nativeWindow;
    }
    
    unloadCheckHQComponent(componentDivId: string, obj: any) {
        if (this.handler) {

          try {
            this.handler.close();
            this.handler = null;
          }catch(err) {
            console.log(err);
          }
        }
      }

    launchCheckComponent(url: string, elementId: string, obj: any) {
        try {
            this.unloadCheckHQComponent( elementId, obj);

            this.handler = (this.nativeWindow as any).CheckComponent.create({
              link: url,
              appearance: {
                  backgroundColor: '#F9FAFB',
                  fontFamily: 'Helvetica',
                  monospaceFontFamily: 'Courier New, monospace',
                  primaryColor: '#4B62FF',
                  includeCloseButton: false,
                  height: "100%",
                  width: "100%",
                  includeLogo: false,
                },
              onEvent: (event, data) => { 
        
             let ev = String(event);
                if (ev.endsWith('-loaded') && obj?.loaded) {
                  obj?.loaded();
                } else if (ev.endsWith('-complete') && obj?.close)  {
                  obj?.close();
                }
              },
            });
        
            this.handler.open();
            const componentElement = this.document.getElementById(
              'check-component-embedded-div',
            );

            if (componentElement) {
              const componentHolder = this.document.getElementById(elementId);

              if (componentHolder) {
                componentHolder.appendChild(componentElement);
              }
            }
          } catch (err) {
            // handle error
            console.log(err);
          }
    }
}
